import React, { FC, ReactNode, useEffect } from 'react'
import { GlobalStyle, Container } from 'Pages/landings/newLandings/common/style'
import { FooterComponent } from './Footer'
import { MenuComponent } from './Menu'

interface ComponentProps {
	title: string
	children: ReactNode
	menuButton?: string
	menuButtonType?: string
	menuButtonText?: string
	footerComponent?: ReactNode
}

export const LayoutComponent: FC<ComponentProps> = ({
	title,
	children,
	menuButton,
	menuButtonType,
	menuButtonText,
	footerComponent,
}) => {
	useEffect(() => {
		window.document.title = title
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])
	return (
		<Container isButton={Boolean(menuButton)}>
			<GlobalStyle />
			<MenuComponent
				buttonScrollTo={menuButton}
				buttonType={menuButtonType}
				buttonText={menuButtonText}
			/>
			{children}
			{footerComponent || <FooterComponent />}
		</Container>
	)
}
